import React from "react";
import { Col, Input, Select } from "antd";
import { retailers, typologies } from "../Constants/temp.constants";

export const TypologyEdition = ({ value = {}, handleChange }) => {
  const { id } = value;
  return (
    <div style={{ margin: 5, display: "flex", alignItems: "center" }}>
      <Col span={5}>
        <span style={{ fontWeight: "bold", marginRight: 5 }}>Typologie </span>
      </Col>
      <Col span={16}>
        <Select defaultValue={id} onChange={handleChange} style={{ width: "100%" }}>
          {typologies.map(({ label_fr, id }) => {
            return (
              <Select.Option key={id} value={id}>
                {label_fr}
              </Select.Option>
            );
          })}
        </Select>
      </Col>
    </div>
  );
};

export const EditAttribute = ({ _key: key, value, handleChange, label }) => {
  return (
    <div style={{ margin: 5, display: "flex", alignItems: "center" }}>
      <Col span={5}>
        <span style={{ fontWeight: "bold", marginRight: 5 }}>{label || key} </span>
      </Col>
      <Col span={16}>
        <Input
          onChange={e => {
            handleChange(e.target.value);
          }}
          defaultValue={value}
          value={value}
        />
      </Col>
    </div>
  );
};

export const RetailerEdition = ({ retailer_id, handleChange }) => {
  return (
    <div style={{ margin: 5, display: "flex", alignItems: "center" }}>
      <Col span={5}>
        <span style={{ fontWeight: "bold", marginRight: 5 }}>Enseigne </span>
      </Col>
      <Col span={16}>
        <Select defaultValue={retailer_id} onChange={handleChange} style={{ width: "100%" }}>
          {retailers.map(({ label, id }) => {
            return (
              <Select.Option key={id} value={id}>
                {label}
              </Select.Option>
            );
          })}
        </Select>
      </Col>
    </div>
  );
};



// WEBPACK FOOTER //
// src/pages/basepdc/Components/CustomInput.component.js